import { RootState } from "../../store";

export const selectGeneralQuestion = (state: RootState) => state.generalQuestion;